import { TableHead, TableRow, TableCell, Checkbox, TableSortLabel, Box } from '@mui/material';
import { EnhancedTableProps, TableHeadCell as HeadCell } from './table-types';
import { visuallyHidden } from '@mui/utils';

interface TableHeadProps<T> extends EnhancedTableProps<T> {
    headCells: HeadCell<T>[];
    showActions: boolean;
    customActionsHeader?: string
    showTableCheckboxes?: boolean;
}

export function EnhancedTableHead<T>(props: TableHeadProps<T>) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;

    const createSortHandler = (property: keyof T) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
    };

    const getCellAlignment = (isNumeric?: boolean) => {
        if (isNumeric === undefined) {
            return 'center';
        }
        return isNumeric ? 'right' : 'left';
    };

    return (
        <TableHead>
            <TableRow>
                {!!props.showTableCheckboxes && (
                    <TableCell padding="checkbox">
                        <Checkbox
                            color="primary"
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={rowCount > 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                            inputProps={{
                                'aria-label': 'select all desserts'
                            }}
                        />
                    </TableCell>
                )}
                {props.headCells.map((headCell, index) => (
                    <TableCell
                        key={`${headCell.id.toString()}-${index}`}
                        align={getCellAlignment(headCell.numeric)}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        style={{ maxWidth: headCell.maxWidth }}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
                {props.showActions && (
                    <TableCell key={`th-actions`} align="center" padding="normal">
                        {props.customActionsHeader ? props.customActionsHeader : 'Actions'}
                    </TableCell>
                )}
            </TableRow>
        </TableHead>
    );
}
